import Divider from '@cobliteam/ui/components/Divider';
import ItemSidebar from '../components/ItemSidebar';
import { trackGlobalSearchEvents } from '../helpers';
import { useSearch } from '../hooks/useSearch';
import type { EnumCategory } from '../types';

const Sidebar = () => {
  const { onChangeCategory, category, counts, sidebar } = useSearch();

  const handleCategoryChange = (params: { categoryId: string; keepSearch: boolean }) => {
    onChangeCategory(params);
    trackGlobalSearchEvents.categoryChange(params.categoryId as EnumCategory);
  };

  return (
    <div className='flex flex-col text-xs'>
      {sidebar.map((group, index) => {
        const hideTitle = group.hideTitle ?? false;
        return (
          <div key={group.name}>
            {!hideTitle && <div className='flex h-9 w-full items-center px-2 text-gray-9'>{group.name}</div>}
            {group.categories.map((item) => {
              return <ItemSidebar key={item.id} item={item} active={category.id === item.id} onChangeCategory={handleCategoryChange} counts={counts} />;
            })}
            {index < sidebar.length - 1 && !hideTitle && <Divider className='my-2' />}
          </div>
        );
      })}
    </div>
  );
};

export default Sidebar;
